import React from "react";
import Image from '../../common/image';
import { Link } from "react-router-dom";
export default function AboutBanner({ data }) {
    return (
        <>
            <section className="about_banner">
                <div className="contain">
                    <div className="cntnt page_pera u_list">
                        <div className="page_heading">
                            <h1>{data.heading}</h1>
                        </div>
                        <p>{data.text}</p>
                        <div className="bTn">
                            <Link to={data.btn_lbl_one_link} className="webBtn colorBtn">{data.btn_lbl_one}</Link>
                            <Link to={data.btn_lbl_two_link} className="webBtn">{data.btn_lbl_two}</Link>
                        </div>
                    </div>
                </div>
                <div className="right_about_img">
                    <Image src={data.image} alt={data.heading} />
                </div>
            </section>
        </>
    )
}
